export const jobPosts = {
  breadcrumb: {
    overview: 'Opdrachten',
    bookmarked: 'Opgeslagen opdrachten',
    own: 'Mijn opdrachten',
    create: 'Opdracht aanmaken',
  },
  alerts: {
    errorApplied: 'Er is iets misgegeaan met het versturen van je reactie, probeer je nog eens?',
    successCancelled: 'Je opdracht werd gemarkeerd als geannuleerd en wordt vanaf nu niet meer publiek getoond.',
    successCreated: 'Je opdracht werd succesvol aangemaakt!',
    successFilled: 'Je opdracht werd gemarkeerd als ingevuld en wordt vanaf nu niet meer publiek getoond.',
    successUpdated: 'Je opdracht werd succesvol bewerkt!',
  },
  card: {
    postedByFreelancer: 'Gepost door een freelancer',
    postedByCS: 'Gecureerd door Creative Shelter',
  },
  apply: {
    actions: {
      submit: 'Ok, verstuur!',
    },
    motivation: {
      explanation: 'Schrijf hier een persoonlijke reactie neer voor je opdrachtgever.',
      title: 'Motivatie',
    },
    profile: {
      contactDetails: 'Contactgegevens',
      explanation: 'Onderstaande gegevens zullen worden gedeeld met de opdrachtgever. Vink uit wat je niet wilt delen.',
      fields: {
        address: 'Adres',
        email: 'E-mailadres',
        links: 'Links',
        phone: 'Telefoonnummer',
      },
      introductionText: 'Introductie',
      title: 'Profiel',
    },
    successDialog: {
      buttonText: 'Got it!',
      description:
        'Je reactie werd verstuurd naar de opdrachtgever. Die ontvangt hiervan een e-mail en neemt daarna contact op met jou. Even wachten dus!',
      title: 'Reactie verstuurd',
    },
    title: 'Contacteer',
  },
  contextMenu: {
    actions: {
      cancelled: 'Opdracht annuleren',
      edit: 'Bewerken',
      filled: 'Opdracht ingevuld',
    },
    dialogs: {
      cancelled: {
        actions: {
          cancel: 'Nee, terug',
          confirm: 'Ja, markeer opdracht geannuleerd',
        },
        description:
          'Hierdoor wordt je opdracht als geannuleerd gemarkeerd en wordt hij niet meer publiek getoond. Dit is niet ongedaan te maken.',
        title: 'Ben je zeker?',
      },
      filled: {
        actions: {
          cancel: 'Nee, terug',
          confirm: 'Ja, markeer als opdracht ingevuld',
        },
        description:
          'Hierdoor wordt je opdracht als ingevuld gemarkeerd en wordt hij niet meer publiek getoond. Dit is niet ongedaan te maken.',
        title: 'Ben je zeker?',
      },
    },
  },
  createEdit: {
    actions: {
      create: 'Opdracht aanmaken',
    },
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je opdracht is nog niet opgeslagen, en alle aanpassingen gaan verloren.',
    sections: {
      basic: {
        title: 'Basis informatie',
      },
      details: {
        title: 'Opdracht details',
      },
      planning: {
        title: 'Planning',
      },
    },
    title: {
      create: 'Opdrachtdetails',
      edit: 'Bewerk opdracht',
    },
  },
  details: {
    actions: {
      alreadyApplied: 'Reeds gecontacteerd',
      apply: 'Contacteer opdrachtgever',
    },
    info: {
      alreadyApplied: {
        description: 'Je hebt de opdrachtgever reeds gecontaceerd. Even wachten dus op antwoord...',
        title: 'Opdrachtgever gecontaceerd',
      },
      userHasCreated: {
        description: 'Je kan er uiteraard zelf niet op reageren, maar je kan de opdracht altijd aanpassen.',
        title: 'Dit is jouw eigen opdracht',
      },
    },
  },
  fields: {
    activities: {
      label: 'Soort opdracht',
      placeholder: 'Selecteer...',
    },
    closesAt: {
      label: 'Reageren voor',
    },
    createdAt: {
      label: 'Aangemaakt op',
    },
    description: {
      label: 'Omschrijving',
    },
    endsAt: {
      label: 'Einddatum',
    },
    experienceLevel: {
      label: 'Ervaring',
      options: {
        Junior: 'Junior',
        Medior: 'Medior',
        Senior: 'Senior',
      },
      placeholder: 'Junior? Medior? Senior?',
    },
    isPriceToBeDiscussed: {
      label: 'Overeen te komen',
    },
    locationType: {
      label: 'Werkplek',
      options: {
        Hybrid: 'Hybrid',
        Onsite: 'Onsite',
        Remote: 'Remote',
      },
      placeholder: 'Onsite? Hybrid? Remote?',
    },
    price: {
      label: 'Budget',
      placeholder: 'Budget',
    },
    priceUnit: {
      label: 'Eenheid',
      options: {
        Daily: 'dag',
        Fixed: 'vaste prijs',
        HalfDaily: 'halve dag',
        Hourly: 'uur',
        PricePerWord: 'woord',
      },
      placeholder: 'Eenheid per prijs',
    },
    region: {
      label: 'Locatie opdracht',
      placeholder: 'Selecteer...',
    },
    startsAt: {
      label: 'Startdatum',
    },
    status: {
      options: {
        Cancelled: 'Geannuleerd',
        Filled: 'Ingevuld',
        Open: 'Open',
      },
    },
    title: {
      label: 'Titel',
      placeholder: 'Titel',
    },
  },
  overview: {
    actions: {
      create: 'Opdracht toevoegen',
    },
    bookmarked: {
      empty: 'Je hebt nog geen opdrachten opgeslagen.',
    },
    description: 'Bekijk hier kwalitatieve opdrachten',
    error: {
      title: 'Fout bij het laden van de opdrachten.',
    },
    filters: {
      activities: 'Selecteer activiteiten...',
      locationType: 'Selecteer werkplek...',
      regions: "Selecteer regio's...",
    },
    loading: 'Laden...',
    own: {
      empty: 'Je hebt nog geen opdrachten aangemaakt.',
    },
    resetFilters: '(filters wissen)',
    resultCount_one: '{{count}} resultaat',
    resultCount_other: '{{count}} resultaten',
    resultCount_zero: 'Geen match gevonden op basis van je zoekcriteria',
    title: 'Opdrachten',
  },
  specifications: {
    closesAt: 'Reageren voor',
    experienceLevel: 'Ervaring',
    location: 'Locatie',
    locationType: 'Werkplek',
    period: 'Periode',
    price: 'Prijs',
  },
  tabs: {
    all: 'Alle opdrachten',
    bookmarked: 'Opgeslagen opdrachten',
    own: 'Eigen opdrachten',
  },
};
